import { createStore } from "vuex";

export default createStore({
  state: {
    brandConfig: undefined,
    msisdn: undefined,
    sessionId: undefined,
  },
  mutations: {
    setBrandConfig(state, brandConfig) {
      state.brandConfig = brandConfig;
    },
    setMsisdn(state, msisdn) {
      state.msisdn = msisdn;
    },
    setSessionId(state, sessionId) {
      state.sessionId = sessionId;
    },
  },
});
